import createPersistedReducer from '@/redux/lib/createPersistedReducer';

const initialState = {
  refreshCompanies: false,
  refreshAuthorization: null
};

const persistConfig = {
  key: 'pubSubReducer',
  whitelist: [],
  transforms: []
};

export default createPersistedReducer(
  initialState,
  {
    GET_PUB_SUB_MESSAGE_refreshCompanies: (state, payload) => ({ ...state, refreshCompanies: payload?.data }),
    CLEAR_REFRESH_COMPANIES: (state) => ({ ...state, refreshCompanies: false }),
    GET_PUB_SUB_MESSAGE_refreshAuthorization: (state, payload) => ({ ...state, refreshAuthorization: payload?.data }),
    CLEAR_REFRESH_AUTHORIZATION: (state) => ({ ...state, refreshAuthorization: null })
  },
  persistConfig
);
